(function () {
  'use strict';

  angular
      .module('tfc.retailer.StandardReports')
      .controller('ShopperSessionsCtrl', ShopperSessionsCtrl);

  // @ngInject
  function ShopperSessionsCtrl(storeKeys, filters, DateUtil, ConsumerChart, TransactionReports, StandardReports,
                               Callout, SectionConfig, CalloutLabelService, ConsumerChartDisplay) {
    var vm = this;

    var detailLevel = filters.pathParams.detailLevel;

    vm.dateRange = {startDate: filters.queryParams.startDate, endDate: filters.queryParams.endDate};

    vm.transactionColorSwatch = StandardReports.getColorSwatches();

    var queryFilters = _.merge(filters.queryParams, {storeKey: storeKeys});
    vm.apiParams = { detailLevel: detailLevel, queryParams: queryFilters };

    var sessionForConversion = SectionConfig.sessionForConversion ;
    var totalSessions = SectionConfig.totalSessions;
    var tfSessions = SectionConfig.tfSessions ;
    var nonTFSessions = SectionConfig.nonTFSessions ;

    vm.sessionForConversionSection = Callout.labelValueConfig(sessionForConversion);
    vm.sessionsForConversionChartData = function(rawData) {
      return rawData;
    };

    vm.totalSessionsSection = Callout.usedForReportingConfig(totalSessions);
    vm.totalSessionChartData = function(rawData) {
      return rawData;
    };

    vm.tfSessionsSection = Callout.usedForReportingConfig(tfSessions);
    vm.tfSessionChartData = function(rawData) {
      return rawData;
    };

    vm.nonTFSessionsSection = Callout.usedForReportingConfig(nonTFSessions);
    vm.nonTFSessionChartData = function(rawData) {
      return rawData;
    };

  }
  })();
